import { ROUTES } from "@routing/routes";
import { Button } from "@common/index";
import { ComponentColor } from "@common/types";
import { useAuth } from "@/hooks/useAuth";
import { signInRedirect } from "@components/Auth/signInRedirect";

export const HomePageFooterCta = () => {
    const { instance } = useAuth();

    const handleSignIn = () => {
        signInRedirect(instance);
    };

    return (
        <section className="bg-base-100">
            <div className="max-w-6xl mx-auto px-4 py-12 lg:py-16 text-center text-primary">
                <h2 className="text-2xl lg:text-4xl font-bold">
                    Get started today!
                </h2>
                <div className="mt-6">
                    <Button
                        to={ROUTES.APPLY}
                        color={ComponentColor.Warning}
                        className="text-base text-neutral font-bold normal-case"
                    >
                        Apply Now
                    </Button>
                </div>
                <p className="mt-6 text-base">
                    Already have an account?{" "}
                    <button
                        type="button"
                        onClick={handleSignIn}
                        className="link link-primary font-bold normal-case"
                    >
                        Sign In
                    </button>
                </p>
            </div>
        </section>
    );
};
